import { features } from "process";
import environment from "../utils/environment";
import { Features, isEnabled } from "./featureToggle";

export interface PathInfo {
    name: string;
    path: string;
};

export enum Paths {
  IMAGES = "IMAGES",
  IMAGES_VENDORS = "IMAGES_VENDORS",
  IMAGES_MISC = "IMAGES_MISC",
  IMAGES_LOGO = "IMAGES_LOGO",
}

// Populate with values here
let paths: PathInfo[];
paths = [];
paths.push({name: Paths.IMAGES, path: "/images"});
paths.push({name: Paths.IMAGES_VENDORS, path: "/images/vendors"});
paths.push({name: Paths.IMAGES_MISC, path: "/images/misc"});
paths.push({name: Paths.IMAGES_LOGO, path: "/images/logo"});

export const getPath = (lookForPath: String, fullPath: boolean) => {

  let returnValue:String  = "";
  const lookFor = paths.find(p => p.name === lookForPath);
  if (lookFor) {
    returnValue = lookFor.path;
  }
  if (!returnValue) {
    return ""; // indicating not found
  }
  if (isEnabled(Features.CDNImages)) {
    return `${environment.CDN_URL}${returnValue}`
  }
  return fullPath ? `${environment.BASE_URL}${returnValue}` : `.${returnValue}`;
}